export default __webpack_public_path__ + "98f947654f57c20c827af80d2667715f.svg";